import { render, staticRenderFns } from "./Dialog_ClassDetail.vue?vue&type=template&id=5ba7e082&scoped=true&"
import script from "./Dialog_ClassDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_ClassDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7e082",
  null
  
)

export default component.exports